import React, { useState, useEffect } from "react"
import { useLazyQuery } from "@apollo/client"
import { useDebouncedValue } from "@mantine/hooks"
import StaticMultiSelector from "../Atoms/StaticMultiSelector"
import getList from "utils/get-list"

const DynamicMultiSelector = ({
  query,
  variables = undefined,
  renderText = undefined,
  renderLabel = undefined,
  renderTag = undefined,
  isServerSide = false,
  ...staticSelectorProps
}) => {
  const [search, setSearch] = useState("")
  const [debouncedSearch] = useDebouncedValue(search, 500)
  const [getData, { data, loading, error }] = useLazyQuery(query, {
    query: query,
    variables: (isServerSide && {
      first: 10,
      skip: 0,
      query: debouncedSearch,
      ...variables,
    }) || { ...variables },
  })

  useEffect(() => {
    getData()
  }, [query, getData])

  if (error) return <>error.message</>
  let list = []
  if (data) {
    list = getList(data)
  }

  return (
    <StaticMultiSelector
      loading={loading}
      items={list}
      renderText={renderText}
      renderTag={renderTag}
      renderLabel={renderLabel}
      setSearch={isServerSide ? setSearch : undefined}
      isServerSide={isServerSide}
      {...staticSelectorProps}
    />
  )
}

export default DynamicMultiSelector
